<template>
    <div>
        <a-page-header   title="响贝云站总概况"    />

        <div class="flexs">
            <div class="left">
                <div class="flex">
                    <div class="router-item" v-for="(item,index) in datas.build_website">
                        <p>{{item.title}}</p>
                        <p @click="gotoStatistics(1,index)">{{item.value}}</p>
                    </div>
                </div>
                <div class="seach">
                    <Seach @dateChang="dateChang " @typeChang="typeChang " :typeNum="num"/>
                </div>
                <div class="chart_box">
                    <div class="title">建站数量</div>
                    <Area   :data ="datab"  :id="idb" :name="name1"  />
                </div>
                <div class="chart_box">
                    <div class="title">活跃网站</div>
                    <Area :data ="dataa" :id="ida" :name="name2"  />
                </div>
            </div>

            <div class="right ">
                <div class="flex">
                    <span class="tit">活跃网站数</span>
                    <div class="router-item" v-for="(item,index) in datas.active_website">
                        <p>{{item.title}}</p>
                        <p @click="gotoStatistics(2,index)">{{item.value}}</p>
                    </div>
                </div>
                <div class="list_box">
                    <p class="title2">
                        <router-link to="/DataStatistics/WebStatistics">独立访客排行榜（UV）<i style="float: right" class="iconfont el-icon-b2cright"></i></router-link>
                    </p>
                    <p class="list flex" :title="item.company" v-for="(item,index) in uv_list"><span>{{item.company}}</span> <span>{{item.uv_total}}</span></p>
                </div>
            </div>
        </div>
<div class="bot">
    <div class="title">top10公司</div>
    <div class="flex">
        <div class="list_box">
            <p class="title2"><router-link to="/DataStatistics/Inquiry">行业<i style="float: right" class="iconfont el-icon-b2cright"></i></router-link></p>
            <p class="list flex" :title="item.name" v-for="(item,index) in datas.industry"><span>{{item.name}}</span> <span>{{item.customer_count}}</span></p>
        </div>
        <div class="list_box">
            <p class="title2"><router-link to="/DataStatistics/ProductArticle">产品数<i style="float: right" class="iconfont el-icon-b2cright"></i></router-link></p>
            <p class="list flex" :title="item.company" v-for="(item,index) in datas.product"><span>{{item.company}}</span> <span>{{item.product_num_count}}</span></p>
        </div>
        <div class="list_box">
            <p class="title2"><router-link to="/DataStatistics/Industrys">询盘量<i style="float: right" class="iconfont el-icon-b2cright"></i></router-link></p>
            <p class="list flex" :title="item.company" v-for="(item,index) in datas.inquiry"><span>{{item.company}}</span> <span>{{item.inquiry_num_count}}</span></p>
        </div>
    </div>
    <div class="flex mgt20">
        <div class="list_box">
            <p class="title2"><router-link to="/DataStatistics/RankVersion">版本<i style="float: right" class="iconfont el-icon-b2cright"></i></router-link></p>
            <p class="list flex" :title="item.name" v-for="(item,index) in version"><span>{{item.name}}</span> <span>{{item.customer_count}}</span></p>
        </div>
        <div class="sourcea">
            <p class="s-type">网站类型</p>
            <CakeChart  :data="cakeData" :id="ids"></CakeChart>
        </div>
    </div>
</div>

    </div>
</template>

<script>
    import Area from "../components/areaChart"
    import Seach from "../components/seach"
    import CakeChart from "../components/cakeChart"
    import API from "./api";
    export default {
        name: "index",
        data(){
            return{
                num:"3",
                datas:[],
                type:"30",
                update_time:[],
                ida:"a",
                idb:"b",
                name1:"建站数量",
                name2:"活跃网站",
                datab:[],
                dataa:[ ],
                uv_list:[],
                cakeData:[],
                ids:"c",
                version:[]
            }
        },
        components:{Area, Seach,CakeChart},

        methods: {
            dateChang(data){
                this.getDetail("",data)
                this.num=""
            },
            typeChang(data){
                this.getDetail(data,"")
                this.num=data
            },
            getDetailAll(){
                API.service.GET_LIST( ).then(res => {
                    this.datas=res.data.data
                    this.version = res.data.data.version.data
                    let siteTypeArr = []
                    res.data.data.siteType.map(function(item){
                        let siteTypeObj = {}
                        siteTypeObj.type = item.name
                        siteTypeObj.value = parseFloat(item.percentage)/100 ;
                        siteTypeObj.num = ""+item.customer_count
                        siteTypeArr.push(siteTypeObj)
                    })
                    this.cakeData = siteTypeArr
                })
            },
            getDetail(type,date) {
                API.service.GET_LIST_CHANGE({a_customer_id:this.id,type:date?"":type||3,search_time:date}).then(res => {
                    this.uv_list=res.data.data.uv_list
                    this.dataa=[]
                    this.datab=[]
                    res.data.data.chart.map((item,index)=>{
                        let jsona={ time:item.time, value:item.active_website_count }
                        this.dataa.push(jsona)
                        let jsonb={ time:item.time, value:item.build_website_count }
                        this.datab.push(jsonb)
                    })
                  console.log("this.dataa",this.dataa)
                  console.log("this.datab",this.datab)
                })
            },
            gotoStatistics(type,value){
                if(type == 1){
                    this.$router.push(`/DataStatistics/WebStatistics?days=${value}&&type=statisticalSummary`)
                }else if(type == 2){
                    this.$router.push(`/DataStatistics/Active?days=${value+1}`)
                }
            }
        },
        created(){
            this.$store.state.adminleftnavnum = "/DataStatistics/StatisticalSummary"; //设置左侧导航2-2 active
            this.getDetailAll()
            this.getDetail()
        },
        mounted() {
            // this.ida=99* Math.floor(Math.random() * 10) + 1+""
            // this.idb=99*Math.floor(Math.random() * 10) + 1+""
            const e = document.createEvent('Event')
            e.initEvent('resize', true, true)
            window.dispatchEvent(e)
        }
    }
</script>

<style scoped>
    .ant-page-header{padding: 16px 0px!important;}
    .flexs{overflow: hidden}
    .left{width:55%;float: left}
    .right{width:calc(45% - 20px);;float: right}
    .left>.flex{ box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);padding:10px 16px;box-sizing: border-box}
    .right>.flex{box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);padding:10px 16px;box-sizing: border-box}
    .right .tit{font-weight: bold; font-size: 18px; position: relative; top: 18px;}
    .title{font-weight: bold;margin-bottom:20px;font-size: 16px}
    .seach{margin: 20px 0}
    .chart_box{margin-top: 20px}
    .list_box{border: 1px solid #f1f1f1;padding: 10px 16px;box-sizing: border-box;margin-top: 120px}
    .list_box .list span:first-child{display: inline-block;width: calc(100% - 65px) ;overflow: hidden;word-break:break-all;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;}
    .list_box .list{line-height: 2.5;color: rgba(0, 0, 0, 0.65);width: 100%;}
    .list_box .title2{text-align: center;color: #3a5a97;font-weight: bold}
    .bot{margin-top: 40px}
    .bot .list_box{width: 32%;margin-top: 0}
    .mgt20{margin-top: 20px;}
    .s-type{padding: 10px 20px;}
    .sourcea{width: 66%;border: 1px solid #f1f1f1;}
    .router-item{text-align: center;}
    .router-item p:nth-of-type(1){    margin-bottom: 4px;
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;}
    .router-item p:nth-of-type(2){color: #1890ff;cursor: pointer;font-size: 24px;margin-bottom: 0;}
    .router-item p.allnum{color: rgba(0, 0, 0, 0.85);}
</style>
